import angular from "angular";
import CreateOrganizationPageComponent from "./create-organization-page/create-organization-page";
import OrganizationNewCardComponent from "./organization-new-card/organization-new-card";
import NotHaveOrganizationPage from "./not-have-organization-page/not-have-organization-page";
import NoOrganizationCard from "./no-organization-card/no-organization-card";

const CreateOrganizationModule = angular
  .module("modules.createOrganization", [])
  .component("createOrganizationPage", CreateOrganizationPageComponent)
  .component("organizationNewCard", OrganizationNewCardComponent)
  .component("notHaveOrganizationPage", NotHaveOrganizationPage)
  .component("noOrganizationCard", NoOrganizationCard);

export default CreateOrganizationModule;
